import { useGetClubDetailsQuery } from '../../../features/SpeechAgendaApiSlice.ts'
import { NavLink, useParams } from 'react-router'
import { useSetTitle } from '../../../app/hooks/UseSetTitle.ts'
import MeetingCardSkeleton from '../../../components/skeletons/MeetingCardSkeleton.tsx'
import MeetingCard from './MeetingCard.tsx'
import { useAppAuth } from '../../../app/hooks/UseAppAuth.ts'
import { useCheckoutReturn } from '../../../app/hooks/UseCheckoutReturn.ts'
import ManageClubButton from '../../../components/club/ManageClubButton.tsx'

function NoMeetingsCopy({ clubId, clubName, isAdmin }: Readonly<{ clubId: string; clubName: string; isAdmin: boolean }>) {
  if (isAdmin) {
    return (
      <div className="py-16 text-center">
        <p className="text-base font-semibold text-gray-900">
          This club doesn't have a meeting schedule yet.
        </p>
        <p className="mt-2 text-sm text-gray-500">
          Head to{' '}
          <NavLink
            to={`/club/${clubId}/admin`}
            className="font-semibold text-indigo-600 hover:text-indigo-500">
            Club Admin
          </NavLink>{' '}
          to set up your schedule and bring this page to life for members and guests.
        </p>
      </div>
    )
  }

  return (
    <div className="py-16 text-center">
      <p className="text-sm text-gray-500">
        {clubName} is getting set up. Check back soon for meeting times and details!
      </p>
    </div>
  )
}

export default function Meetings() {
  const { isAuthenticated, userLoaded } = useAppAuth()
  const { clubId: clubIdPathParameter } = useParams()

  const {
    data: clubDetails,
    isLoading,
    isFetching,
    //TODO: Use pagination
  } = useGetClubDetailsQuery(clubIdPathParameter as string, {
    skip: !clubIdPathParameter || !userLoaded,
  })

  useCheckoutReturn(
    clubIdPathParameter,
    clubDetails ? clubDetails.roleId === 1 : undefined
  )

  useSetTitle(clubDetails?.clubName)

  if (isFetching || isLoading || !userLoaded) {
    return (
      <div className="flex flex-wrap cards-container-justify">
        {[...Array(6)].map((_, index) => (
          <MeetingCardSkeleton key={index} />
        ))}
      </div>
    )
  }

  const isAdmin = clubDetails?.roleId === 1
  const clubHasNoMeetings = clubDetails?.meetings.length === 0

  return (
    <div className="relative">
      <ManageClubButton
        clubId={clubIdPathParameter}
        isVisible={Boolean(isAuthenticated && isAdmin)}
      />
      {clubHasNoMeetings ? (
        <NoMeetingsCopy
          clubId={clubIdPathParameter as string}
          clubName={clubDetails.clubName}
          isAdmin={isAdmin}
        />
      ) : (
        <div className="flex flex-wrap cards-container-justify">
          {clubDetails?.meetings.map((meeting) => (
            <MeetingCard meeting={meeting} key={meeting.timestampUtc} />
          ))}
        </div>
      )}
    </div>
  )
}
